import * as React from 'react';
import clsx from 'clsx';
import { isMobile } from 'react-device-detect';
import { Popover, IPopover, CloseButton } from 'components';
import { getContainerIcon } from 'utils';

interface ILegendItemWithPopoverProps extends React.HTMLAttributes<HTMLDivElement> {
    popoverProps?: Omit<Partial<IPopover>, 'open'>;
    container: omjs.IContainer;
}

export const LegendItemWithPopover = ({
    popoverProps = {},
    container,
    className: classNameForDiv,
    children,
    ...restDivProps
}: ILegendItemWithPopoverProps) => {
    const [ referenceElement, setReferenceElement ] = React.useState<HTMLDivElement>(null);
    const [ showPopover, setShowPopover ] = React.useState<boolean>(false);
    let {
        ref,
        ...restPopoverProps
    } = popoverProps;
    return (
        <React.Fragment>
            <div
                ref={setReferenceElement}
                className={clsx('category-panel-item__controls-legend-item', classNameForDiv)}
                onClick={() => setShowPopover(true)}
                onMouseEnter={() => setShowPopover(true)}
                onMouseLeave={() => setShowPopover(false)}
                {...restDivProps}
            >
                <img src={getContainerIcon(container)} alt="" />
            </div>

            {!isMobile && (
                <Popover
                    open={showPopover}
                    hideTimeout={300}
                    showTimeout={300}
                    targetElement={referenceElement}
                    offset={[ 0, 16 ]}
                    placement="bottom"
                    {...restPopoverProps}
                >
                    { children }
                </Popover>
            )}
        </React.Fragment>
    );
};
